import React from 'react'
import './welcome.css'
import img375 from '../../../assets/images/section-one/pizza.webp'
import img700 from '../../../assets/images/section-one/pizza.webp'
import img1440 from '../../../assets/images/section-one/pizza.webp'
import PizzaOne from '../../../assets/images/welcome-section/pizza-one-parallax.webp'
import PizzaTwo from '../../../assets/images/welcome-section/pizza-two-parallax.webp'
import { motion } from "framer-motion";

const imageParentVariant = {
  initial: {},
  whileInView: {}
}


const leftImageVariant = {
  initial: { opacity: 0, left: -100, top: 100 },
  whileInView: {
    opacity: 0.7, left: 0, top: 100,
    transition: { duration: 4 }
  },

}

const rightImageVariant = {
  initial: { opacity: 0, right: -100, top: 100 },
  whileInView: {
    opacity: 0.7, right: 0, top: 100,
    transition: { duration: 4, }
  },

}

const WelcomeSection = () => {
  return (
    <article className="homepage__welcome">
      <motion.section className="welcome__info flex-container flex-column txt-center pop-font"
        variants={imageParentVariant}
        initial={"initial"}
        whileInView={"whileInView"}>
        <motion.img
          loading='lazy'
          src={PizzaOne} alt="" 
          aria-hidden="true"
          variants={leftImageVariant}
          width={500}
          height={499}
        />
        <motion.img
          loading='lazy'
          src={PizzaTwo} alt=""
           aria-hidden="true"
          variants={rightImageVariant}
          width={500}
          height={499}
        />
        <h2 className="txt-white">
          Willkommen im <span>Casaantonio e piccolo gió</span> Restaurant
        </h2>
        <p>
        Bei Casaantonio e piccolo gió heben wir Pizza auf ein neues Level – Stück für Stück! Unser Erfolg basiert auf einer einzigartigen Markenidentität und tiefem Know-how in der Pizzabranche. Wir wissen, wonach Menschen sich sehnen, und verwandeln diese Wünsche in unvergessliche Geschmackserlebnisse. Frische Zutaten, Originalität und Qualität stehen im Mittelpunkt von allem, was wir tun. Mit fairen Preisen und unserem einladenden Standort in Salzburg-Itzling machen wir es einfach, großartige Pizza zu genießen. Und dank unseres reibungslosen Online-Bestellsystems ist deine Lieblingspizza nur einen Klick entfernt. Bei Casaantonio e piccolo gió bist du nicht nur ein Kunde – du bist der Grund, warum wir tun, was wir tun!
        </p>
      </motion.section>
      <img
        className="welcome__cover"
        src={img375}
        srcSet={`${img1440} 1440w, ${img700} 700w, ${img375} 375w`}
        sizes="(min-width: 1440px) 1440px, (min-width: 700px) 700px, 375px"
        alt="Casaantonio e piccolo gió Restaurant-Innenraum mit Gästen am Tisch und Personal beim Servieren"
        loading="lazy"
      />
    </article>
  )
}

export default WelcomeSection;